import React, { useEffect } from 'react';

import {
  BaratinhasCount,
  BaratinhasCountLabel,
  Container,
  CurrentCarBadge,
  CurrentLevelContainer,
  CurrentLevelInfo,
  CurrentLevelName,
  Header,
  Image,
  ProductImage,
  ProductValueContainer,
  Value,
  ValueContainer,
  ValueDescription,
  ValueGroup,
} from './styles';
import {AchievementsShimmer} from '../../../../../../Interface/Loadings/AchievementsShimmer';
import {RFValue} from 'react-native-responsive-fontsize';
import {useHelpers} from '../../../../../../../context/helpers';
import {useCarrinhos} from '../../../../../../../context/useCarrinhos';
import {Baratinhaz} from '../../../../../../Interface/Baratinhaz';
import {Platform} from 'react-native';
import {PedidoDTO} from '../../../../../../../dtos/PedidoDTO';
import {Localidade} from '../../types';
import { useNavigation } from '@react-navigation/native';


type Props = {
  isLoading?: boolean;
  pedidos: PedidoDTO;
  localidade: Localidade;
  totalValue: number;
};

export function CoreHeader({
  isLoading,
  pedidos,
  localidade,
  totalValue,
}: Props) {
  const navigation = useNavigation();
  const {formatNumberToLocaleAmount} = useHelpers();
  const {
    currentCarImage,
    currentGanhoCompra,
    refetch,
    loading: loadingAchievements,
    error: loadingCarError,
  } = useCarrinhos();


  useEffect(() => {
    refetch();
  }, []);
  return (
    <Container>
      <Header>
        <ProductValueContainer>
          <ProductImage source={{uri: pedidos.imageUrl}} />
          <ValueContainer>
            <Value>
              {isLoading ? '••••' : formatNumberToLocaleAmount(totalValue)}
            </Value>

            <ValueGroup>
              <ValueDescription numberOfLines={1} ellipsizeMode="tail">
                {localidade.cidade}, {localidade.estado}
              </ValueDescription>
            </ValueGroup>
          </ValueContainer>
        </ProductValueContainer>

        {Platform.OS !== 'web' && (
          <>
            {loadingAchievements ? (
              <AchievementsShimmer />
            ) : (
              !loadingCarError && (
                <CurrentLevelContainer
                  activeOpacity={0.7}
                  onPress={() => navigation.navigate('Achievements')}>
                  <CurrentLevelInfo>
                    <CurrentLevelName>Você ganha:</CurrentLevelName>
                    <BaratinhasCount>
                      <Baratinhaz width={RFValue(10)} height={RFValue(10)} />
                      <BaratinhasCountLabel>
                        +{currentGanhoCompra} btz
                      </BaratinhasCountLabel>
                    </BaratinhasCount>
                  </CurrentLevelInfo>
                  <CurrentCarBadge>
                    <Image
                      source={currentCarImage}
                      resizeMode="contain"
                      style={{
                        width: RFValue(40),
                        height: RFValue(40),
                        resizeMode: 'contain',
                      }}
                    />
                  </CurrentCarBadge>
                </CurrentLevelContainer>
              )
            )}
          </>
        )}
      </Header>
    </Container>
  );
}
